import { render, staticRenderFns } from "./AddTextModal.vue?vue&type=template&id=442aee8c"
import script from "./AddTextModal.vue?vue&type=script&lang=js"
export * from "./AddTextModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports